export const RESET_CUSTOMER_DASHBOARD_ISFETCHING =
  'RESET_CUSTOMER_DASHBOARD_ISFETCHING';
export const GET_CUSTOMER_DASHBOARD_REQUEST = 'GET_CUSTOMER_DASHBOARD_REQUEST';
export const GET_CUSTOMER_DASHBOARD_SUCCESS = 'GET_CUSTOMER_DASHBOARD_SUCCESS';
export const CUSTOMER_DASHBOARD_OBJECT_REQUESTING =
  'CUSTOMER_DASHBOARD_OBJECT_REQUESTING';
